import { IBaseEntity, IIssueEntity, IProjectEntity, PartialUpdate } from "@common/interfaces/base";
import { ID } from "@common/interfaces/id";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore, EntityStoreAction, QueryEntity, runEntityStoreAction } from "@datorama/akita";
import { ActionService } from "./action/action.service";
import { UpdateStoreStrategy } from './updateStoreStrategies';
import { merge } from '@corex/deepmerge';
import { ObjectHelpers as OH } from '@common/utils/object.helpers';
import { diff } from "deep-object-diff";
import { WsACKCallback } from "@common/api/ack";
export abstract class CrudService<
  T extends IBaseEntity,
  Store extends EntityStore<EntityState<T>>,
  Query extends QueryEntity<EntityState<T>>
  > {

  //protected abstract topic: Topics;

  constructor(
    protected topic: Topics,
    protected store: Store,
    protected query: Query,
    protected actionService: ActionService,
    protected updateStoreStrategy: UpdateStoreStrategy
  ) {
    this.updateStoreStrategy?.start(this.topic, this.store.constructor.name);
  }

  setLoading(isLoading: boolean) {
    this.store.setLoading(isLoading);
  }

  create(payload: T) {
    delete payload.createdAt;
    delete payload.updatedAt;
    delete payload.lastUpdatedBy;
    this.store.add(payload);
    this.actionService.queueAction({ topic: this.topic, type: 'create', payload });
  }

  delete(id: ID) {
    this.update({ id, deletedAt: (new Date()).toISOString() } as PartialUpdate<T>);
  }

  restore(id: ID) {
    this.update({ id, deletedAt: null } as PartialUpdate<T>);
  }

  localRemoveEntity(id: ID) {
    this.store.remove(id);
  }

  
  localRemoveEntities(ids: ID[]) {
    if (this.topic === Topics.IID_GENERIC_SUSPENSION) {
      console.log('removing generic_suspension for', ids);
      console.log(this.query.getAll().filter(e => ids.includes(e.id)));
    }
    this.store.remove(ids);
  }

  localRemoveByIssueAndProject(issue: ID, project: ID) {
    this.store.remove(({ projectId, issueId }) => projectId === project && issueId === issue )
  }

  
  localRemoveByIssue(issue: ID) {
    if (this.topic === Topics.ISSUES) {
      console.log('removing issue ', issue)
      console.log(this.query.getAll().filter((e: any) => e.issueId === issue ));
    }
    this.store.remove(({issueId}) => issueId === issue);
  }

  removeByProject(projectId: ID) {
    const entities = this.query.getAll({
      filterBy: (entity: unknown) => {
        const issueEntity = entity as IProjectEntity;
        return issueEntity.projectId === projectId;
      }
    });
    for (const elem of entities) {
      this.localRemoveEntity(elem.id)
    }
  }

  update(data: PartialUpdate<T>) {
    const previous = this.query.getEntity(data.id);
    let payload = diff(previous, data);
    if (OH.hasNestedObject(data)) {
      payload = merge([payload, data]);
    }

    OH.purgeUndefined(payload);
    const resultObject = {};
    for(const key of Object.keys(payload)) {
      resultObject[key] = data[key];
    }

    if (!OH.hasProps(payload)) {
      //callback && callback();
      return;
    }
    payload = { id: data.id, ...resultObject }
    this.store.upsert(data.id, data);
    this.actionService.queueAction({ topic: this.topic, type: "update", payload: payload, backup: previous })
  }

  remoteGet(queryParam: object) {
    this.actionService.queueAction({topic: this.topic, type: 'get', payload: queryParam});
  }
}
